// 引入vuex
import { mapState, mapMutations } from "vuex";
import axios from 'axios'
import {
    // loginSystem,
    // getListEngineer,
    getOrgList,
    getUser,
    getUserList
  
  } from '@/api/api'

  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'id' },
    },
    {
      title: '用户名',
      dataIndex: 'loginName',
    },
    {
      title: '姓名',
      dataIndex: 'name',
    },
    {
      title: '职务',
      dataIndex: 'duty',
    },
    {
      title: '归属单位',
      dataIndex: 'companyName',
    },
    {
      title: '手机号码',
      dataIndex: 'mobile',
    },
    {
      title: '邮箱',
      dataIndex: 'email',
    },
  ];
  const data = [
    {
      key: '1',
      name: 'John Brown',
      age: 32,
      address: 'New York No. 1 Lake Park',
    },
    {
      key: '2',
      name: 'Jim Green',
      age: 42,
      address: 'London No. 1 Lake Park',
    },
    {
      key: '3',
      name: 'Joe Black',
      age: 32,
      address: 'Sidney No. 1 Lake Park',
    },
  ];

  const treeData = [
    {
      title: '沿太行新乡段',
      key: 'tree1',
      children: [
        {
          title: '指挥部',
          key: '0-0-0',
          children: [
            { title: '工程部', key: '0-0-0-0' },
            { title: '综合部', key: '0-0-0-1' },
          ],
        },
        {
          title: '施工标',
          key: '0-0-1',
          children: [
            { title: '施工1标', key: '0-0-1-0' },
          ],
        },  
      ],
    },
  ];

  const orgList = [];
  const userList = [];
export default {
    data() {
        return {
            val: 'Hello moto',
            expandedKeys: ['0-0-0', '0-0-1'],
            autoExpandParent: true,
            checkedKeys: ['0-0-0'],
            selectedKeys: [],
            treeData,
            data,
            columns,
            orgList,
            engineerName:'',
            userList,
            ModalText: 'Content of the modal',
            visible: false,
            confirmLoading: false,
            pagination: {
              current: 1,
              total: 11,
              pageSize: 10, //每页中显示10条数据
              showSizeChanger: true,
              showQuickJumper: true,
              // position:['bottomLeft'],
              pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
              // showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
              showTotal: (total, range) => `显示${range[0]}-${range[1]}条，共有 ${total}条` //分页中显示总的数据
            },
        }
        
    },
    created() {

    },
    mounted() {
        //console.log(this.val)
        //this.getVal()
        this.getOrgLists()
        this.getUsers()
        this.getUserLists()
    },
    methods: {
      handleChange(value) {
        console.log(`selected ${value}`);
      },
      async getOrgLists() {
        let params = {
          baseId:'1',
        };
      await getOrgList(params).then(res => {
         this.orgList = res.data.data.records;
         this.engineerName = this.orgList[0].id
        })
      },
      async getUsers() {
      await getUser().then(res => {
        })
      },
      async getUserLists() {
        let params = {
          orgId:'1',
        };
        await getUserList(params).then(res => {
          debugger
          if(res.data.code == 200){
            this.userList = res.data.data.records;
          }
          })
        },
          // 分页
        handleTableChange(pagination, filters, sorter) {
          console.log(pagination)
          this.pagination = pagination
          this.getTableList()
        },
        onExpand(expandedKeys) {
            console.log('onExpand', expandedKeys);
            // if not set autoExpandParent to false, if children expanded, parent can not collapse.
            // or, you can remove all expanded children keys.
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
          },
          onCheck(checkedKeys) {
            console.log('onCheck', checkedKeys);
            this.checkedKeys = checkedKeys;
          },
          onSelect(selectedKeys, info) {
            console.log('onSelect', info);
            this.selectedKeys = selectedKeys;
          },
        // 引入store方法
        ...mapMutations(['updateCount']),
        // // 登录测试接口
        // async getVal() {
        //     let params = {
        //         username:'admin',
        //         password: '87654321jsadmin'
        //       };
        //     await loginSystem(params).then(res => {
        //        console.log(res)
        //     //    登录后存储token令牌
        //        localStorage.setItem('OAtoken','74c8ffe4a59da108f03aa7afc77cc24e')
        //       })
        //     //   修改vuex属性
        //     this.updateCount(2)
        //     console.log(this.count)
        // },
        // 根据cookie查询接口
        // async getListEngineers() {
        //   let k = {
        //     k:va,          }
        //     await getListEngineer().then(res =        // async getListEngineers() {
        //   let k = {
        //     k:va,          }
        //     await getListEngineer().then(res => {
        //         console.log(res)
        //     })
        // },> {
        //         console.log(res)
        //     })
        // },
        showModal() {
            this.visible = true;
        },
        handleOk(e) {
            this.ModalText = 'The modal will be closed after two seconds';
            this.confirmLoading = true;
            setTimeout(() => {
              this.visible = false;
              this.confirmLoading = false;
            }, 2000);
          },
          handleCancel(e) {
            console.log('Clicked cancel button');
            this.visible = false;
          },
    },
    watch: {
        checkedKeys(val) {
            console.log('onCheck', val);
        },
    },
    // 引入store属性
    computed: {
      //mapState(["count"])
      mapState(){
        ["count"]
      },
      rowSelection() {
        return {
          onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          },
          getCheckboxProps: record => ({
            props: {
              disabled: record.name === 'Disabled User', // Column configuration not to be checked
              name: record.name,
            },
          }),
        };
      }
    }
}


// WEBPACK FOOTER //
// ./src/views/HomePage/HomePage-mixins.js